import { useTranslation } from 'react-i18n-lite'
import { useLoginContext } from './LoginContext'
import { Button, Unifree } from '@yes.technology/react-toolkit'

type Props = {
  goToAuthentication: () => void
}

function MFA({ goToAuthentication }: Props) {
  const { t } = useTranslation()
  const { handleMfaLogin, mfaCode, setMfaCode } = useLoginContext()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    handleMfaLogin()
  }

  return (
    <form
      style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      onSubmit={handleSubmit}
    >
      <p style={{ margin: 0 }}>{t('login.mfa.hint')}</p>
      <Unifree
        label={t('login.mfa.code')}
        placeholder={t('login.mfa.code')}
        name='mfa_code'
        value={mfaCode}
        onChange={setMfaCode}
        autoFocus
        maxLength={6}
      />
      <Button disabled={mfaCode.length !== 6} type='submit'>
        {t('login.mfa.continue')}
      </Button>
      <Button onClick={goToAuthentication} variant='secondary'>
        {t('login.mfa.go-back')}
      </Button>
    </form>
  )
}

export default MFA
